import React, { Component } from 'react';
import { connect } from 'react-redux';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getBranchesLatest } from '../../store/actions';
import Service from '../../services';
import { baseUrlAdmin } from '../../store/apiConstants';
import { exportToExcel } from '../../utils/excelExport';

class CumulativeAnalysis extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedBranches: [],
            selectedTemplate: null,
            selectedExams: [],
            examOptions: [],
            templates: [],
            reportData: [],
            tableLoading: false,
            overallTotalMarks: 0,
            subjectTotalMarks: {},
        };
        this.service = new Service();
    }

    getTemplates() {
        const academicYear = localStorage.getItem('userAcademicYear');
        this.service
            .get(`${baseUrlAdmin}/examtemplate/getAllTemplates?academicYear=${academicYear}`, {}, true)
            .then((response) => {
                if (response.status && response?.res?.success) {
                    this.setState({
                        templates: response.res.data
                    });
                }
            })
            .catch((error) => {
                console.error('Error fetching templates:', error);
                this.toast?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch templates',
                    life: 3000
                });
            });
    }

    getExams(branchIds, templateId) {
        if (!branchIds?.length || !templateId) return;

        let filters = {
            branchIds: branchIds,
            templateId: templateId,
            academicYear: localStorage.getItem('userAcademicYear')
        };

        this.service
            .post(`${baseUrlAdmin}/academicsReports/cumulativeStudentExamReport/exams`, filters, true)
            .then((response) => {
                if (response.status && response?.res?.status) {
                    const exams = response.res.data || [];

                    this.setState({
                        examOptions: exams,
                        selectedExams: []
                    });
                }
            })
            .catch((error) => {
                console.error('Error fetching exams:', error);
                this.toast?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch exams',
                    life: 3000
                });
            });
    }

    getSubjectColumns() {
        const { templates, selectedTemplate, subjectTotalMarks } = this.state;
        if (!selectedTemplate) return [];

        const templateObj = templates.find(
            t => t._id === selectedTemplate || (t._id && t._id.$oid === selectedTemplate)
        );
        if (!templateObj || !Array.isArray(templateObj.subjects)) return [];

        const metrics = [
            { field: 'marks', header: 'Marks' },
            { field: 'percent', header: '%' },
            { field: 'rank', header: 'Rank' },
            { field: 'correct', header: 'correct' },
            { field: 'wrong', header: 'wrong' },
            { field: 'UA', header: 'UA' },
        ];

        return templateObj.subjects.flatMap((subject, subjectIndex) => {
            const subNum = subjectIndex + 1;
            const subjectMarks = subjectTotalMarks[`Sub ${subNum}`] || 0;

            return metrics.map(metric => (
                <Column
                    key={`sub${subNum}_${metric.field}`}
                    field={`sub${subNum}_${metric.field}`}
                    header={
                        metric.field === 'marks'
                            ? `Sub ${subNum} Marks (${subjectMarks} marks)`
                            : `Sub ${subNum} ${metric.header}`
                    }
                />
            ));
        });
    }

    onTemplateChange = (e) => {
        const selectedTemplate = e.value;
        this.setState({ selectedTemplate }, () => {
            if (this.state.selectedBranches.length > 0) {
                this.getExams(this.state.selectedBranches, selectedTemplate);
            }
        });
    }

    onBranchesChange = (e) => {
        const selectedBranches = e.value;
        this.setState({ selectedBranches }, () => {
            if (this.state.selectedTemplate) {
                this.getExams(selectedBranches, this.state.selectedTemplate);
            }
        });
    }

    onViewAnalysis = () => {
        const { selectedBranches, selectedTemplate, selectedExams } = this.state;
        const academicYear = localStorage.getItem('userAcademicYear');
        if (!selectedBranches.length || !selectedTemplate || !selectedExams.length) {
            this.toast?.show({
                severity: 'warn',
                summary: 'Missing Filters',
                detail: 'Please select branches, template, and exams.',
                life: 3000
            });
            return;
        }

        const filters = {
            branchIds: selectedBranches,
            templateId: selectedTemplate,
            examIds: selectedExams,
            academicYear
        };

        this.setState({ tableLoading: true });

        this.service
            .post(`${baseUrlAdmin}/academicsReports/cumulativeStudentExamReport`, filters, true)
            .then((response) => {
                if (response.status && response?.res?.status) {
                    // Get template object to know number of subjects
                    const templateObj = this.state.templates.find(
                        t => t._id === selectedTemplate || (t._id && t._id.$oid === selectedTemplate)
                    );
                    const numSubjects = templateObj?.subjects?.length || 0;

                    const reportData = (response.res.data || []).map(student => {
                        // First, initialize all subject fields with 0
                        for (let i = 1; i <= numSubjects; i++) {
                            student[`sub${i}_marks`] = 0;
                            student[`sub${i}_percent`] = 0;
                            student[`sub${i}_rank`] = 0;
                            student[`sub${i}_correct`] = 0;
                            student[`sub${i}_wrong`] = 0;
                            student[`sub${i}_UA`] = 0;
                        }

                        // Then override with actual data if it exists
                        if (student.subjects && Array.isArray(student.subjects)) {
                            student.subjects.forEach((subj, idx) => {
                                const subNum = idx + 1;
                                student[`sub${subNum}_marks`] = subj.marks || 0;
                                student[`sub${subNum}_percent`] = subj.totalMarks ? Math.round((subj.marks / subj.totalMarks) * 100) : 0;
                                student[`sub${subNum}_rank`] = subj.rank || 0;
                                student[`sub${subNum}_correct`] = subj.correct || 0;
                                student[`sub${subNum}_wrong`] = subj.wrong || 0;
                                student[`sub${subNum}_UA`] = subj.ua || 0;
                            });
                        }
                        return student;
                    });

                    this.setState({
                        reportData,
                        totalRecords: response.res.totalRecords,
                        tableLoading: false,
                        overallTotalMarks: response.res.overallTotalMarks || 0,
                        subjectTotalMarks: response.res.subjectTotalMarks || {}
                    });
                } else {
                    this.setState({ tableLoading: false });
                }
            })
            .catch((error) => {
                console.error('Error fetching cumulative report:', error);
                this.toast?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch cumulative report',
                    life: 3000
                });
                this.setState({ tableLoading: false });
            });
    };

    onDownloadReport = () => {
        const exportColumns = [
            { field: 'studentId', header: 'Student ID' },
            { field: 'studentName', header: 'Student Name' },
            { field: 'branchName', header: 'Branch Name' },
            { field: 'classSection', header: 'Class-Section' },
            { field: 'totalExams', header: 'Total Exams' },
            { field: 'overallMarks', header: `Overall Marks (${this.state.overallTotalMarks} marks)` },
            { field: 'overallPercent', header: 'Overall %' },
            { field: 'overallRank', header: 'Overall Rank' },
            { field: 'overallCorrect', header: 'Overall correct' },
            { field: 'overallWrong', header: 'Overall wrong' },
            { field: 'overallUA', header: 'Overall UA' }
        ];

        // Add subject columns dynamically
        const templateObj = this.state.templates.find(
            t => t._id === this.state.selectedTemplate || (t._id && t._id.$oid === this.state.selectedTemplate)
        );

        if (templateObj && Array.isArray(templateObj.subjects)) {
            templateObj.subjects.forEach((subject, idx) => {
                const subNum = idx + 1;
                const subjectMarks = this.state.subjectTotalMarks[`Sub ${subNum}`] || 0;

                exportColumns.push(
                    { field: `sub${subNum}_marks`, header: `Sub ${subNum} Marks (${subjectMarks} marks)` },
                    { field: `sub${subNum}_percent`, header: `Sub ${subNum} %` },
                    { field: `sub${subNum}_rank`, header: `Sub ${subNum} Rank` },
                    { field: `sub${subNum}_correct`, header: `Sub ${subNum} correct` },
                    { field: `sub${subNum}_wrong`, header: `Sub ${subNum} wrong` },
                    { field: `sub${subNum}_UA`, header: `Sub ${subNum} UA` }
                );
            });
        }

        exportToExcel(this.state.reportData, 'Cumulative_Analysis_Report', exportColumns);
    };

    componentDidMount() {
        // this.props.getBranchesLatest(true);
        this.getTemplates();
    }

    render() {
        const { branchData } = this.props;
        const { selectedBranches, selectedTemplate, selectedExams, reportData, templates, examOptions, overallTotalMarks } = this.state;

        return (
            <div style={{ padding: 24 }}>
                <div className="card filters-card mb-3">
                    <div className="flex gap-4">
                        {/* Branches MultiSelect */}
                        <div style={{ minWidth: 250 }}>
                            <p className="add-vehicle-field-label">
                                Branches <span style={{ color: 'red' }}>*</span>
                            </p>
                            <ClassetMultiSelect
                                value={selectedBranches}
                                options={branchData}
                                onChange={this.onBranchesChange}
                                optionLabel="name"
                                optionValue="key"
                                placeholder="Select Branches"
                                width="100%"
                                height="48px"
                            />
                        </div>
                        {/* Test Template Dropdown */}
                        <div style={{ minWidth: 250 }}>
                            <p className="add-vehicle-field-label">
                                Test Template <span style={{ color: 'red' }}>*</span>
                            </p>
                            <ClassetDropdown
                                value={selectedTemplate}
                                options={templates}
                                onChange={this.onTemplateChange}
                                optionLabel="name"
                                optionValue="_id"
                                placeholder="Select Template"
                                width="100%"
                                height="48px"
                            />
                        </div>
                        <div style={{ minWidth: 250 }}>
                            <p className="add-vehicle-field-label">
                                Exam Name <span style={{ color: 'red' }}>*</span>
                            </p>
                            <ClassetMultiSelect
                                value={selectedExams}
                                options={examOptions}
                                onChange={e => this.setState({ selectedExams: e.value })}
                                optionLabel="examName"
                                optionValue="examId"
                                placeholder="Select Examination"
                                width="100%"
                                height="48px"
                            />
                        </div>
                        {/* Buttons */}
                        <div className="flex align-items-end gap-2 ml-auto">
                            <Button
                                label="Download Report"
                                className="p-button-secondary"
                                onClick={this.onDownloadReport}
                                disabled={!this.state.reportData.length || this.state.tableLoading}
                            />
                            <Button
                                label="View Analysis"
                                className="p-button-primary"
                                onClick={this.onViewAnalysis}
                                disabled={
                                    !selectedBranches.length ||
                                    !selectedTemplate ||
                                    !selectedExams.length ||
                                    this.state.tableLoading // <-- disable while loading
                                }
                            />
                        </div>
                    </div>
                </div>
                {/* Table */}
                <DataTable
                    value={reportData}
                    paginator
                    rows={10}
                    responsiveLayout="scroll"
                    loading={this.state.tableLoading}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                >
                    <Column field="studentId" header="Student ID" />
                    <Column field="studentName" header="Student Name" />
                    <Column field="branchName" header="Branch Name" />
                    <Column field="classSection" header="Class-Section" />
                    <Column field="totalExams" header="Total Exams" />
                    <Column field="overallMarks" header={`Overall Marks (${overallTotalMarks} marks)`} />
                    <Column field="overallPercent" header="Overall %" />
                    <Column field="overallRank" header="Overall Rank" />
                    <Column field="overallCorrect" header="Overall correct" />
                    <Column field="overallWrong" header="Overall wrong" />
                    <Column field="overallUA" header="Overall UA" />
                    {/* Dynamically generated subject columns */}
                    {this.getSubjectColumns()}
                </DataTable>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    branchData: (state.branchDataLatest?.data?.data.filter((each) => each.level === 1)) || [],
});

export default connect(mapStateToProps, { getBranchesLatest })(CumulativeAnalysis);